import React from 'react'
import { useDebounce } from 'use-debounce'
import { Timing } from '@cbgms/base/utils/timing'
import { useQueryClient } from '@cbgms/base/http/use-query'
import { useProductQueryResultTypes } from './use-product-query-result-types'
import { ProductSearchResultType } from '@cbgms/components/src/product-search/types/IProductSearchResultProps'

export const PRODUCT_SEARCH = 'PRODUCT_GROUP_ORDERS_SEARCH'

export const useProductSearch = (resultTypes: ProductSearchResultType[], orderAccountID: string, initialQuery = '') => {
  const [loading, setLoading] = React.useState(false)
  const queryClient = useQueryClient()
  const [query, setQuery] = React.useState(initialQuery)
  const [debouncedQuery] = useDebounce(query, Timing.fastKeyboardInput, { leading: true })

  const { data: searchResponse, isInitialLoading } = useProductQueryResultTypes(checkQuery, debouncedQuery, resultTypes, orderAccountID)

  React.useEffect(() => {
    setLoading(isInitialLoading || query !== debouncedQuery)
  }, [isInitialLoading, query, debouncedQuery])

  React.useEffect(() => {
    if (query === '') {
      queryClient.invalidateQueries([PRODUCT_SEARCH])
    }
  }, [query, queryClient])

  function checkQuery(q: string) {
    return q?.length >= 2
  }

  const clearQuery = () => {
    setQuery('')
  }

  return { loading, setLoading, query, setQuery, clearQuery, searchResponse }
}
